import styles from "./ForgotPassword.module.scss"
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import useAppDispatch from "../../../hooks/useAppDispatch";
import {useState} from "react";
import {Form} from "antd";
import {getLanguageFromLocal} from "../../../helpers/language.helper";
import {AuthService} from "../../../services/auth.service";
import {IForgotPasswordStep1Request} from "../../../models/Auth";
import {openMessage} from "../../../store/notification/notificationSlice";
import LoginFormItemInput from "../../../components/UI/LoginFormItemInput/LoginFormItemInput";
import LoginFormItemInputPassword from "../../../components/UI/LoginFormItemInputPassword/LoginFormItemInputPassword";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";

export const ForgotPassword = () => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [step, setStep] = useState<"email" | "otp" | "newPassword">("email");
    const [email, setEmail] = useState<string>("");
    const [otp, setOtp] = useState<string>("");

    const onFinish = async (values: { email: string, otp: string, password: string, confirmPassword: string }) => {
        try {
            if (step === "email") {
                const model: IForgotPasswordStep1Request = {
                    email: values.email,
                    locale: getLanguageFromLocal(),
                    type: "email"
                }
                const response = await AuthService.forgotPasswordStep1(model);
                if (response.data.success) {
                    dispatch(openMessage({type: "success", title: t("ConfirmationCodeSent")}));
                    setEmail(model.email);
                    setStep("otp");
                } else {
                    dispatch(openMessage({type: "error", title: t("EmailNotfound", {email: model.email})}));
                    setStep("email");
                }
            }
            if (step === "otp") {
                setOtp(values.otp);
                const model = {
                    email,
                    otp: values.otp
                }
                const response = await AuthService.forgotPasswordStep2(model);
                if (response.data?.success && response.data?.data.valid) {
                    dispatch(openMessage({type: "success", title: t("EnterOneTimePasswordCorrectly")}));
                    setStep("newPassword");
                } else {
                    dispatch(openMessage({type: "error", title: t("EnterOneTimePasswordCorrectly")}));
                    setStep("otp");
                }
            }
            if (step === "newPassword") {
                if (values.password !== values.confirmPassword) {
                    dispatch(openMessage({title: t("OtpCodeConfirmed"), type: "success"}));
                    return;
                }
                if (values.password.length < 6) {
                    dispatch(openMessage({title: t("PasswordMustBeLonger"), type: "error"}));
                    return;
                }
                const model = {
                    email,
                    otp,
                    password: values.password
                }
                const response = await AuthService.forgotPasswordStep3(model);
                if (response.data.data.valid && response.data.success) {
                    dispatch(openMessage({title: t("PasswordChangedSuccessfully"), type: "success"}));
                    navigateToLogin();
                    return;
                } else {
                    dispatch(openMessage({title: t("SomethingWentWrong"), type: "error"}));
                }

            }
        } catch (e) {
            dispatch(openMessage({title: t("SomethingWentWrong"), type: "error"}));
        }
    };

    const navigateToLogin = () => {
        navigate("/auth/login");
    }

    return (
        <div className={styles.wrapper}>
            <h2 className={styles.title}>{t("ForgotPassword")}?</h2>
            <Form
                className={styles.form}
                name={"forgot-password"}
                onFinish={onFinish}
            >
                {step === "email" && (
                    <LoginFormItemInput
                        name={"email"}
                        label={t("EmailAddress")}
                        rules={{required: true}}
                    />
                )}
                {step === "otp" && (
                    <LoginFormItemInput
                        name={"otp"}
                        label={t("EnterOneTimePassword")}
                        rules={{required: true}}
                    />
                )}

                {step === "newPassword" && (
                    <>
                        <LoginFormItemInputPassword
                            name={"password"}
                            label={t("Password")}
                            rules={{required: true}}
                        />
                        <LoginFormItemInputPassword
                            name={"confirmPassword"}
                            label={t("ConfirmPassword")}
                            rules={{required: true}}
                        />
                    </>
                )}
                <div className={styles.btnWrapper}>
                    <CustomButton
                        text={step === "email" ? t("SendMessage") : step === "otp" ? t("ValidateOTP") : t("ChangePassword") }
                        type={"submit"}
                        typeStyle={"fill"}
                        borderRadius={true}
                    />
                    <CustomButton
                        text={t("GoToLogin")}
                        type={"button"}
                        typeStyle={"outline"}
                        borderRadius={true}
                        functionOnClick={navigateToLogin}
                    />
                </div>
            </Form>

        </div>
    )
}

export default ForgotPassword;